module.exports = __webpack_public_path__ + "static/media/9.865d6824.png";